import { Planogram } from 'app/types/machines/planogram'

/** The quantity max of a product in the planogram. */
export const QUANTITY_MAX = 30

export const planogramSettings = {
    ACTIVATION_MIN: 0,
    ACTIVATION_MAX: 2_000,
    ALARM_LOW_TRIGGER: 2,
    ALARM_MINIMUM: 0,
    DISPENSATION_SPEED: 6,
    DISPENSATION_MOTOR_ACTIVATION_AFTER: 0,
    LEVEL_DEFAULT: 5,
    LINE_SELECTION_DEFAULT: 3,
    SPEED_MIN: 1,
    SPEED_MAX: 9,
    STOCK_LIMIT: 30,
    STOCK_MAXIMUM: 10,
    STOCK_RECOMMENDED: 8,

    distributor: {
        LEVEL_MAX: 8,
        LINE_SELECTION_MAX: 10,
    },

    fridgeWeight: {
        LEVEL_MAX: 7,
        LINE_SELECTION_DEFAULT: 5,
        LINE_SELECTION_MAX: 5,
        SIZE_SELECTION_MIN: 12,
        SIZE_TOTAL: 61,
    },

    locker: {
        LEVEL_MAX: 10,
        LINE_SELECTION_MAX: 5,
    },
}

/** Find free name for new mapping. */
export const formatMapping = (planogram: Planogram) => {
    let name
    let number = 1

    while (!name) {
        const mappingToTest = number < 10 ? `0${number}` : String(number)

        const foundMapping = planogram.selections.findIndex(
            (selection) => selection.mapping === mappingToTest,
        )

        if (foundMapping === -1) {
            name = mappingToTest
        }

        number++
    }

    return name
}

/** Search parameters used in the planogram page. */
export const searchParametersPlanogram = {
    CLIENTS: 'clients',
    MACHINE_TYPE: 'machine_type',
    MANAGERS: 'managers',
    NAME: 'name',
    SITES: 'sites',
    STATUS: 'status',
}

/** Get translation key of planogram selection error. */
export const errorTypeSelectionTranslate = {
    EMPTY: 'locationErrorEmpty',
    MAPPING: 'locationErrorDuplicate',
    MOTOR: 'locationErrorMotor',
    NAME: 'locationErrorPlanogramName',
    PLANOGRAM_ORDER: 'locationErrorPlanogramOrder',
}

/** Get translation key of planogram status. */
export const planogramStatusTranslate = {
    ALL: 'all',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PENDING: 'pending',
}
